export const sidebars = {
  left:  { light: "#e2e8f0", dark: "#121d36" },
  right: { light: "#e2e8f0", dark: "#121d36" }
};
